import React from 'react';
import { Field, reduxForm } from 'redux-form';
import FileField from './FileInput'


const validate = {
	photo: value => value ? undefined : 'Photo is required',
}

const renderError = ({ meta: { touched, error } }) => 
  touched && error ? <p className="form-error is-visible" id="uuid">{error}</p> : false 

const UploadImageForm = props => {
  const { handleSubmit, previousPage, pristine, submitting } = props

  return (
		<form onSubmit={handleSubmit} className="registartion-upload-image-form">

			<section className="section gray-bg">
				<div className="grid-x align-center">
				<div className="small-12 medium-10 large-8 cell text-center">


					<Field 
						className="artist-photo-dropzone"
						name="photo" 
						component={ FileField }  
						accept="image/jpeg,image/jpg,image/tiff,image/gif,image/png" 
						multiple={ false } 
						/>

					<Field name="photo" validate={[validate.photo]} component={renderError} />

					<div className="row">
						<div className="small-12 medium-centered text-center column">

							<div className="custom-checkbox">
                <Field
                  className="styled-checkbox"
                  name="no_image"
                  id="no-image"
                  component="input"
                  type="checkbox"
                />
                {
                	// <label htmlFor="no-image">I can't now or don't have image. Please email me and will add later</label>
                }
              </div>


						</div>
					</div>

				</div>
				</div>
			</section>

			<section className="section registration-action-buttons">
				<div className="grid-x align-center">
					<div className="small-12 cell text-center">
						<button className="button primary" 
              type="submit" 
              disabled={pristine || submitting}>
                {submitting ? 'Loading...' : 'Next' }
            </button>
						
					</div>
				</div>
			</section>
		</form>
  	)
}

export default reduxForm({
  form: 'artistRegistrationWizard', // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  // validate
})(UploadImageForm)


// WEBPACK FOOTER //
// ./src/components/UploadImageForm.js